import React, { useState } from 'react'
import { SettingsLayout } from '@/components/layouts/settings-layout'
import { css } from '@emotion/core'
import { useTranslation } from 'react-i18next'
import { dashboardPageContainerStyle } from '@/constants/layout'
import { SubmitHandler, useForm } from 'react-hook-form'
import { FormFooter } from '@/components/organisms/settings/mail-delivery/form-footer'
import { DeliveryMethod, MailDeliveryContentInput, isReservation } from '@/models/mail-delivery/mail-delivery-content'
import { saveMailDeliveryContent } from '@/apis/aipass'
import { errorHandler } from '@/libs/errors'
import { useHistory } from 'react-router-dom'
import { FormMailContent } from '@/components/organisms/settings/mail-delivery/form-mail-content'
import { defaultValues, FormDeliveryCondition } from '@/components/organisms/settings/mail-delivery/form-delivery-condition'

export const MailDeliveryContentNew: React.FC = () => {
  const [loading, setLoading] = useState(false)
  const { t } = useTranslation()
  const history = useHistory()
  const useFormReturn = useForm<MailDeliveryContentInput>({ defaultValues })

  const onSubmit: SubmitHandler<MailDeliveryContentInput> = async submitData => {
    try {
      setLoading(true)
      const result = await saveMailDeliveryContent(DeliveryMethod.Mail, submitData)
      if (isReservation(submitData.status)) {
        return history.push({ pathname: `/setting/mail-delivery` })
      } else {
        return history.push({ pathname: `/setting/mail-delivery-content/mail/${result.id}` })
      }
    } catch (error) {
      errorHandler(error)
    } finally {
      setLoading(false)
    }
  }

  return (
    <SettingsLayout
      loading={loading}
      footerContent={
        <FormFooter
          method={DeliveryMethod.Mail}
          onSave={useFormReturn.handleSubmit(onSubmit)}
          onCancel={() => history.push({ pathname: `/setting/mail-delivery` })}
          useFormReturn={useFormReturn}
        />
      }
    >
      <div css={dashboardPageContainerStyle}>
        <div css={headerSettingStaffStyle}>
          <div css={headerDetailStyle}>{t('Delivery Details')}</div>
        </div>
        <FormMailContent useFormReturn={useFormReturn} />
        <FormDeliveryCondition useFormReturn={useFormReturn} />
      </div>
    </SettingsLayout>
  )
}

const headerSettingStaffStyle = css({
  height: '50px',
  padding: '0 32px',
  borderBottom: '1px solid #F2F2F2',
  display: 'flex',
  justifyContent: 'space-between',
})

const headerDetailStyle = css({
  fontSize: '18px',
  fontWeight: 'bold',
  padding: '16px 0',
  color: '#272727',
})
